export function toCompositeId(resourceType: string, resourceId: string) {
  return `${resourceType}:${resourceId}`;
}

export function fromCompositeId(compositeId: string) {
  if (!compositeId || typeof compositeId !== "string" || !compositeId.includes(":")) {
    return {
      resourceType: undefined,
      resourceId: undefined,
    };
  }

  const [resourceType, resourceId] = compositeId.split(":");

  return {
    resourceType,
    resourceId,
  };
}
